import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { FormaPagamentoRequest, Response } from './Types';

class FormaPagamentoController {
  public static async Listar(
    request: FormaPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller FormaPagamento Listar');
      console.log(request);

      const response = await Api.post('api/formapagamento/Listar', request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(FormaPagamentoId: number): Promise<Response> {
    try {
      console.log('Controller FormaPagamento Listar Unico');
      console.log(FormaPagamentoId);

      const response = await Api.get(
        `api/formapagamento/ListarUnico/${FormaPagamentoId}`
      );

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(
    request: FormaPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller FormaPagamento Adicionar');
      console.log(request);

      const response = await Api.post(`api/formapagamento/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(
    request: FormaPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller FormaPagamento Atualizar');
      console.log(request);

      const response = await Api.put(`api/formapagamento/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(
    request: FormaPagamentoRequest
  ): Promise<Response> {
    try {
      console.log('Controller FormaPagamento Excluir');
      console.log(request);

      const response = await Api.put(`api/formapagamento/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default FormaPagamentoController;
